import { SearchModes } from '../../constants';

const checkDoSkipTripConfiguration = (store) => {
  const { travelAgency } = store.user;
  return (
    travelAgency &&
    travelAgency.enabledTransportModes &&
    travelAgency.enabledTransportModes.length === 1 &&
    travelAgency.enabledTransportModes[0] === +SearchModes.HOTEL &&
    travelAgency.settings &&
    travelAgency.settings.disableMultipleRoomBookings
  );
};

export default checkDoSkipTripConfiguration;
